/**
 * WeekSchedule — rolling next-7-days opening hours, evaluated in the gym's
 * timezone with date-specific specialHours overrides applied. Today is
 * highlighted; special (holiday / one-off) days show their label.
 * Presentational only; shared by GymSelector cards and GymInfoModal.
 */
import React from "react";
import { getWeekSchedule } from "../utils";
import { SELECTABLE } from "./ui";
import { useTranslation } from "../i18n";
import { useAppTheme } from "../contexts/ThemeContext";

// "YYYY-MM-DD" → "MM.DD." (locale-neutral, matches HU short date style)
const shortDate = (dateStr) => `${dateStr.slice(5, 7)}.${dateStr.slice(8, 10)}.`;

export function WeekSchedule({ openingHours, specialHours, timezone, accent, dense }) {
  const { th } = useAppTheme();
  const { t } = useTranslation();
  const week = getWeekSchedule(openingHours, specialHours, timezone);
  const fs = dense ? 12 : 13;

  return (
    <div>
      <div style={{ fontSize: dense ? 12 : 13, fontWeight: 700, color: dense ? th.textMuted : th.text, marginBottom: dense ? 4 : 8 }}>
        {t('gymEditor.openingHours')}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: dense ? 2 : 4 }}>
        {week.map((d) => {
          const value = d.hours ? `${d.hours.open} – ${d.hours.close}` : t('gymSelector.closedNow');
          return (
            <div key={d.dateStr} style={{
              display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 10, fontSize: fs,
              fontWeight: d.isToday ? 700 : 400,
            }}>
              <span style={{ color: d.isToday ? accent : th.textMuted, fontWeight: d.isToday ? 700 : 600, flexShrink: 0 }}>
                {d.isToday ? t('gymSelector.today') : t('gymEditor.' + d.dayKey + 'Full')} <span style={{ fontWeight: 400, opacity: 0.7 }}>{shortDate(d.dateStr)}</span>
              </span>
              <span style={{ textAlign: "right", color: d.hours ? (d.isToday ? th.text : th.text) : th.textMuted, minWidth: 0 }}>
                {d.special && d.label && (
                  <span style={{ color: accent, fontWeight: 600, marginRight: 6, ...SELECTABLE }}>{d.label}</span>
                )}
                {d.special && !d.label && (
                  <span style={{ color: accent, fontWeight: 600, marginRight: 6 }}>★</span>
                )}
                {value}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
